import Image from 'next/image';
import React from 'react';
import ClientCarousel from '../home/client-carousel';
import ScheduleCall from '../common/schedule-call';

type Props = {
    path: any;
    alt: string;
    title: string;
    width: number;
    height: number;
    desc: string;
    className?: string;
    color?: string;
    isRed?: boolean;
    isGreen?: boolean;
    isOrange?: boolean;
    children: any;
    bgPath?: any;
};

const TechHero: React.FC<Props> = ({
    path,
    alt,
    title,
    width,
    height,
    children,
    desc,
    className,
    color,
    isRed,
    isGreen,
    isOrange,
    bgPath,
}) => {
    return (
        <section className={`hero home-hero technology-herosection ${className}`}>
            <div className="container lg:container md:mx-auto top-hero">
                <div className="lg:grid hero-row gap-6 relative z-[1] h-full">
                    <div className="w-full">
                        <div className="inline-flex flex-col gap-5 justify-center h-full lg:items-start hero-content">
                            <h1 className="mb-0 dark:text-textcolor">{children}</h1>
                            <p className="mb-0 font-semibold text-secondary dark:text-secondary">{desc}</p>
                            <ScheduleCall />
                        </div>
                    </div>
                    <div className="text-center lg:text-start lg:self-center web-hero">
                        <div className="hero-tech-img">
                            {isRed ? (
                                <picture className={`pic-bg ${color}`}>
                                    <source
                                        media="(max-width: 767px)"
                                        width="839"
                                        height="807"
                                        srcSet={`/img/hero/hero-bg-grunge-${color}-mobile@2x.webp`}
                                    />
                                    <source
                                        media="(max-width: 992px)"
                                        width="1021"
                                        height="983"
                                        srcSet={`/img/hero/${bgPath}.webp`}
                                    />
                                    <source
                                        media="(min-width: 1200px)"
                                        width="2042"
                                        height="1965"
                                        srcSet={`/img/hero/${bgPath}@2x.webp`}
                                    />
                                    <Image
                                        alt="bg pattern"
                                        width="1021"
                                        height="983"
                                        priority
                                        src={`/img/hero/${bgPath}.webp`}
                                        quality={100}
                                    />
                                </picture>
                            ) : isGreen ? (
                                <picture className={`pic-bg ${color}`}>
                                    <source
                                        media="(max-width: 767px)"
                                        width="839"
                                        height="765"
                                        srcSet={`/img/hero/hero-bg-grunge-${color}-mobile@2x.webp`}
                                    />
                                    <source
                                        media="(max-width: 992px)"
                                        width="1022"
                                        height="933"
                                        srcSet={`/img/hero/${bgPath}.webp`}
                                    />
                                    <source
                                        media="(min-width: 1200px)"
                                        width="2043"
                                        height="1864"
                                        srcSet={`/img/hero/${bgPath}@2x.webp`}
                                    />
                                    <Image
                                        alt="bg pattern"
                                        width="1022"
                                        height="933"
                                        priority
                                        src={`/img/hero/${bgPath}.webp`}
                                        quality={100}
                                    />
                                </picture>
                            ) : isOrange ? (
                                <picture className={`pic-bg ${color}`}>
                                    <source
                                        media="(max-width: 767px)"
                                        width="839"
                                        height="753"
                                        srcSet={`/img/hero/hero-bg-grunge-${color}-mobile@2x.webp`}
                                    />
                                    <source
                                        media="(max-width: 992px)"
                                        width="1022"
                                        height="917"
                                        srcSet={`/img/hero/${bgPath}.webp`}
                                    />
                                    <source
                                        media="(min-width: 1200px)"
                                        width="2043"
                                        height="1832"
                                        srcSet={`/img/hero/${bgPath}@2x.webp`}
                                    />
                                    <Image
                                        alt="bg pattern"
                                        width="1022"
                                        height="917"
                                        priority
                                        src={`/img/hero/${bgPath}.webp`}
                                        quality={100}
                                    />
                                </picture>
                            ) : (
                                <picture className={`pic-bg ${color}`}>
                                    <source
                                        media="(max-width: 767px)"
                                        width="839"
                                        height="830"
                                        srcSet={`/img/hero/${bgPath}-mobile@2x.webp`}
                                    />
                                    <source
                                        media="(max-width: 992px)"
                                        width="1032"
                                        height="1021"
                                        srcSet={`/img/hero/${bgPath}.webp`}
                                    />
                                    <source
                                        media="(min-width: 1200px)"
                                        width="1547"
                                        height="1532"
                                        srcSet={`/img/hero/${bgPath}@2x.webp`}
                                    />
                                    <Image
                                        alt="bg pattern"
                                        width="1032"
                                        height="1021"
                                        priority
                                        src={`/img/hero/${bgPath}.webp`}
                                        quality={100}
                                    />
                                </picture>
                            )}
                            <picture className="hero-vue-img z-[1]">
                                <source media="(max-width: 767px)" srcSet={`/img/hero/${path}.webp`} />
                                <source media="(min-width: 768px)" srcSet={`/img/hero/${path}@2x.webp`} />
                                <img
                                    src={`/img/hero/${path}.webp`}
                                    width={width}
                                    height={height}
                                    alt={alt}
                                    title={title}
                                    loading="lazy"
                                />
                            </picture>
                        </div>
                    </div>
                </div>
            </div>
            <ClientCarousel />
        </section>
    );
};

export default TechHero;
